export enum FeatureFlags {
  DirectKMS = 'direct-kms',
  RippleWalletGeneration = 'ripple-wallet-generation',
}
